'use client'

import { pageSectionTypes } from 'components/ContentHandlersAppRouter/pageSectionTypes'
import { usePersonalization } from 'providers/PersonalizationProvider'

export function ClientExperimentBoundary({
  children,
  isControl = false,
  showWhenEligible = false,
  variationUiComponents = [],
  hasRenderedVariation = false,
  isCrawler,
}) {
  const { eligible } = usePersonalization()
  const canRenderVariation =
    hasRenderedVariation ||
    variationUiComponents.some((uiComponent) => pageSectionTypes[uiComponent])
  const showSelectedOutcome = !isCrawler && eligible === true && canRenderVariation

  return (showSelectedOutcome ? showWhenEligible : isControl) ? children : null
}
